import React from 'react'

import SvgIcon from 'Pods/Shared/SvgIcon'

function GoogleIcon() {
  return (
    <SvgIcon>
      <i className="custom-font-icon icon-google-plus" />
    </SvgIcon>
  )
}

export default GoogleIcon
